import { Component, Vue } from 'vue-property-decorator';
import { Location } from 'vue-router';

@Component
export default class PageListMixin extends Vue {
  // Methods
  pageLimitChange(limit: string) {
    const { hash, name, params, query = {} } = this.$route;
    const to: Location = {
      name,
      hash,
      params,
      query: {
        ...query,
        limit,
      },
    };
    delete to.query!.page;
    this.$router.push(to);
  }
}



// WEBPACK FOOTER //
// ./src/pages/mixin-list.ts